import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "event-loading",
  templateUrl: "./event-page-loading-animation.component.html",
  styleUrls: ["./event-page-loading-animation.component.scss"],
})
export class EventPageLoadingAnimationComponent implements OnInit {
  public state: "spinning" | "check" = "spinning";
  @Input("saveAnimationTime") saveAnimationTime: number = 2000;

  @Input("run") set run(value: number) {
    if (value > 0) {
      this.state = "spinning";
      setTimeout(
        () => (this ? (this.state = "check") : null),
        this.saveAnimationTime
      );
    }
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-loading-animation/event-page-loading-animation.component.ts